import "./App.css"
import SimpleBottomNavigation from "./tabs/layout/SimpleBottomNavigation"
import React, { Suspense, useEffect, useState } from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import "bootstrap/dist/css/bootstrap.min.css"
import WinningBets from "./tabs/winning/WinningBets"
import AcceptedBets from "./tabs/acceptedbets/AcceptedBets"
import "primereact/resources/themes/mdc-light-indigo/theme.css"
import "primereact/resources/primereact.min.css"
import "primeicons/primeicons.css"
import { detectIncognito } from "detectincognitojs"
import { getCookie } from "./utils/cookies"
import Passcode from "./login/Passcode.js"
import { useGlobalState } from "./helpers/state"
import { ClearandRefresh } from "./services/autoclearServices"
import { GetIdleTime } from "./services/MainServices"

const MainUi = React.lazy(() => import("./tabs/main/MainUi"))
const Scan = React.lazy(() => import("./tabs/scan/Scan"))
const Incognito = React.lazy(() => import("./nonincognito/index"))

function App() {
  const [usercookies, setUsercookies] = useGlobalState("userCookies")
  const isLoggedIn = usercookies
  const [isAllowed, setIsAllowed] = useState(null)

  console.log("allowed: " + isAllowed)

  console.log("Login : " + isLoggedIn)

  // return () => {
  //   mounted = false
  // }
  useEffect(() => {
    let mounted = true

    const checkAccess = async () => {
      try {
        const isReactNativeWebView =
          typeof window !== "undefined" && !!window.ReactNativeWebView

        const appTabMode =
          typeof window !== "undefined" ? window.__APP_TAB_MODE__ : undefined

        // allow only private tab in React Native WebView
        if (isReactNativeWebView) {
          if (mounted) setIsAllowed(appTabMode === "private")
          return
        }

        // normal browser: allow only incognito
        const result = await detectIncognito()
        if (mounted) setIsAllowed(!!result.isPrivate)
      } catch (e) {
        console.log("Access check failed:", e)
        if (mounted) setIsAllowed(false)
      }
    }

    checkAccess()
  }, [])

  useEffect(() => {
    if (!isAllowed) return

    let cancelled = false
    // Start when the app page opens, including the PIN page. Do not make
    // logout depend on the settings request completing successfully.
    let cleanup = ClearandRefresh()

    const loadIdleTimeout = async () => {
      try {
        const result = await GetIdleTime()
        const parsed = Number(result?.value)
        if (
          Number.isSafeInteger(parsed) &&
          parsed >= 15 &&
          parsed <= 3600 &&
          !cancelled
        ) {
          cleanup?.()
          cleanup = ClearandRefresh(parsed)
        }
      } catch (e) {
        console.log("Using default idle timeout")
      }
    }

    loadIdleTimeout()

    return () => {
      cancelled = true
      cleanup?.()
    }
  }, [isAllowed, isLoggedIn])

  if (isAllowed === null) return null

  if (!isAllowed) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/*" element={<Incognito />} />
        </Routes>
      </Suspense>
    )
  }

  return (
    <>
      {isLoggedIn && <SimpleBottomNavigation />}

      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {!isLoggedIn && (
            <>
              <Route path="/" element={<Passcode />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          )}

          {isLoggedIn && (
            <>
              // <Route path="/" element={<Passcode />} />
              <Route path="/main" element={<MainUi />} />
              <Route path="/scan" element={<Scan />} />
              <Route path="/winning" element={<WinningBets />} />
              <Route path="/bets" element={<AcceptedBets />} />
            </>
          )}
        </Routes>
      </Suspense>
    </>
  )
}

export default App
